<ng-container *ngIf="showEnviosBtn">
    <plex-button *ngIf="mostrarFichaEpidemiologica()" type="info" [size]="btnSize" icon="file-tree" class="ml-1"
                 (click)="irFichaEpidemiologica()" tooltipPosition="left" tooltip="Fichas epidemiológicas"
                 tooltipPosition="left">
    </plex-button>
    <plex-button type="info" [size]="btnSize" icon="download" tooltip="Descargar PDF" class="ml-1"
                 [disabled]="requestInProgress" (click)="descargarInforme()" tooltipPosition="left">
    </plex-button>
    <plex-button type="info" [size]="btnSize" icon="email" [disabled]="requestInProgress" *ngIf="getHasEmail() | async"
                 tooltip="Enviar PDF" (click)="openModalEmails()" class="ml-1" tooltipPosition="left">
    </plex-button>
</ng-container>

<modal-seleccion-email *ngIf="showModalEmails" (email)="enviarPDF($event)">
</modal-seleccion-email>